var _circle, _circle2, _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _g3, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle3, _circle4, _circle5, _circle6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFailFeedback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 84,
    fill: "#F7F8FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_17172",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 168,
    height: 168
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 84,
    fill: "#F6F7FA"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_17172)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.6114 82.5473C71.6114 82.5473 62.1294 82.1576 60.9604 83.1968C59.554 83.8651 57.3235 90.7304 73.6896 91.6396C90.0558 92.5488 71.6114 82.5473 71.6114 82.5473Z",
    fill: "#FFC4AF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_17172",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 82,
    width: 22,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6124 82.547C71.6124 82.547 62.1304 82.1574 60.9614 83.1965C59.555 83.8648 57.3245 90.7301 73.6906 91.6393C90.0568 92.5486 71.6124 82.547 71.6124 82.547Z",
    fill: "#FFD0BF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_17172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5035 96.3009C69.5035 93.9132 67.5138 85.8547 66.0215 81.3778L72.9856 80.8804L74.9753 92.8188C72.8198 94.9744 69.5035 98.6886 69.5035 96.3009Z",
    fill: "#FAB6A0"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4783 96.2661C74.4783 96.2661 65.4678 106.028 65.4678 112.133C65.9344 116.333 72.0011 113.066 72.0011 113.066C72.0011 113.066 69.6678 124.157 74.4783 124.157C74.4783 124.157 73.384 130.126 76.4681 130.624C80.4947 131.273 79.9287 119.955 79.9287 119.955L74.4783 96.2661Z",
    fill: "#FFC4AF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_17172",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 96,
    width: 15,
    height: 35
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6935 96.7985C73.6935 96.7985 66.0215 106.114 66.0215 112.219C66.5189 116.696 71.4933 113.214 71.4933 113.214C71.4933 113.214 68.503 125.067 74.4779 124.157C74.4779 124.157 73.483 130.624 76.9651 130.624C80.9917 131.274 79.9282 119.956 79.9282 119.956L73.6935 96.7985Z",
    fill: "#FFD0BF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_17172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.4883 110.726C72.4883 107.542 70.4985 102.435 69.5037 100.28L68.5088 95.3055H72.4883L77.4626 105.752L83.4319 124.157C81.2763 128.468 76.9652 136.294 76.9652 133.111C76.9652 129.927 75.6387 125.152 74.9755 123.162C75.3734 120.376 73.4831 113.711 72.4883 110.726Z",
    fill: "#FAB6A0"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4932 113.213C71.4932 113.213 74.473 110.343 78.4996 102.03",
    stroke: "#F5A386",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9805 124.158C73.9805 124.158 77.8494 123.853 79.7977 109.435",
    stroke: "#F5A386",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.264 63.3224C72.264 63.3224 64.7304 64.3615 66.5488 71.8952C68.3673 79.4288 80.3172 133.593 80.3172 133.593C80.3172 133.593 81.4862 138.789 89.6693 137.1C97.8523 135.411 90.9682 117.227 90.9682 117.227L72.264 63.3224Z",
    fill: "#A5AFBF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.641 91.6854L111.645 91.6993V132.208L89.4418 136.744L89.4175 136.749L89.397 136.756L89.3961 136.756L89.3952 136.756L89.3948 136.756C89.3917 136.757 89.3853 136.759 89.3757 136.761C89.3565 136.766 89.3247 136.774 89.2818 136.782C89.1958 136.799 89.0663 136.818 88.9044 136.826C88.5799 136.842 88.1321 136.81 87.6421 136.621C86.6901 136.254 85.4459 135.238 84.6965 132.427C83.9206 129.518 80.352 113.655 76.9729 98.4974C75.2844 90.9235 73.6446 83.5322 72.4269 78.0343C71.8181 75.2854 71.3148 73.0099 70.9637 71.4216L70.557 69.5813L70.4502 69.0978L70.4229 68.974L70.416 68.9427L70.4143 68.9349L70.4138 68.9329C70.4137 68.9325 70.4137 68.9322 69.9279 69.0394L70.4137 68.9322L70.4102 68.9166L70.4061 68.9022L70.406 68.9019L70.4059 68.9016L70.4059 68.9015L70.4058 68.9011L70.4041 68.895C70.4023 68.8884 70.3994 68.8773 70.3955 68.8621C70.3878 68.8315 70.3765 68.7843 70.3635 68.7224C70.3374 68.5985 70.3047 68.4169 70.2804 68.1939C70.2314 67.7454 70.2176 67.1432 70.3499 66.5111C70.4816 65.8819 70.7561 65.2308 71.2796 64.6646C71.7994 64.1023 72.5901 63.5962 73.8004 63.2911L99.8877 58.4889L99.8914 58.4884C99.8971 58.4875 99.9069 58.486 99.9206 58.4842C99.948 58.4805 99.9906 58.4752 100.047 58.4699C100.159 58.4593 100.323 58.4486 100.525 58.4495C100.93 58.4514 101.473 58.5003 102.036 58.683C102.596 58.8649 103.17 59.1773 103.656 59.7054C104.14 60.2318 104.557 60.9963 104.769 62.1179C105.227 64.5349 106.951 71.953 108.557 78.7495C109.361 82.1515 110.136 85.4033 110.711 87.8045C110.998 89.0052 111.235 89.9932 111.4 90.6811L111.591 91.4768L111.641 91.6854Z",
    fill: "url(#paint0_linear_1_17172)",
    stroke: "#C7CEDB",
    strokeWidth: 0.994872
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_17172",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 58,
    width: 42,
    height: 79
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9801 63.6682L99.9129 59.038C99.9129 59.038 104.287 58.2761 105.162 62.9745C106.037 67.673 111.785 91.9272 111.785 91.9272V131.985L90.0399 136.499C90.0399 136.499 86.4157 137.642 84.916 131.928C83.4163 126.213 71.1688 69.8318 71.1688 69.8318C71.1688 69.8318 68.9812 64.9381 73.9801 63.6682Z",
    fill: "url(#paint1_linear_1_17172)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_17172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.9761 126.644L104.325 55.5105L57.0684 59.49L74.9761 126.644Z",
    fill: "url(#paint2_linear_1_17172)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4336 64.6213L89.9281 63.3224",
    stroke: "#B5BDCB",
    strokeWidth: 1.2989,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3968 71.6312C94.3968 71.6312 95.2708 71.4866 96.3228 70.5287C96.7804 70.112 97.2194 69.5275 97.5693 69",
    stroke: "#A10000",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0355 74.5541C84.0355 74.5541 83.2148 74.8875 81.8172 74.6206C81.2093 74.5045 80.5296 74.2356 79.9556 73.9688",
    stroke: "#A10000",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.708 72.1966C97.6755 73.4646 96.4002 75.5332 96.4002 75.5332C96.4002 75.5332 99.869 74.7224 104 75.9367",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5747 78.1585C82.8225 77.6548 84.9909 78.752 84.9909 78.752C84.9909 78.752 81.6098 79.8736 78.7225 83.0677",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6047 84.1436C99.6047 84.1436 96.8019 82.1379 92.6576 83.3071C88.5134 84.4762 87.172 87.6509 87.172 87.6509",
    stroke: "#B61313",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M106.811 104.758C104.025 102.37 102.002 93.8144 101.339 89.8349L107.308 91.3272L113.775 100.778L114.272 131.122L107.308 132.614C102.931 124.257 105.153 110.727 106.811 104.758Z",
    fill: "#B5BDCB",
    fillOpacity: 0.3
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M167.667 160.199C167.667 160.199 144.763 142.367 142 139.973C137.346 135.941 130.326 128.237 126.169 115.93C119.545 96.3163 120.324 97.2255 117.206 94.3679C114.089 91.5103 110.322 90.8609 105.776 83.9767C105.776 83.9767 104.737 81.1191 101.75 82.2881C98.7621 83.4572 101.49 96.0565 109.673 103.2C109.673 103.2 104.323 120.179 110.322 132.815L95.3691 136.097C95.3691 136.097 98.8512 144.553 106.166 146.324C110.582 147.883 112.271 147.883 116.427 153.338C120.454 158.793 137.8 180.266 137.8 180.266L167.667 160.199Z",
    fill: "#FFD0BF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.1074 135.495C99.755 138.372 104.005 144.825 109.649 146.191C110.189 146.381 110.688 146.549 111.156 146.705C114.515 147.831 116.262 148.416 119.91 153.205C123.194 157.654 136.125 172.534 140.783 177.871L137.8 179.799C137.8 179.799 120.455 158.793 116.428 153.337C112.78 148.549 111.033 147.964 107.674 146.838C107.206 146.681 106.707 146.514 106.167 146.323C98.8522 144.552 95.3701 136.096 95.3701 136.096L98.1074 135.495Z",
    fill: "url(#paint3_linear_1_17172)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.828 82.2579C101.258 85.4947 104.649 96.5367 111.786 102.768C111.786 102.768 105.787 122.464 111.786 135.101L110.036 132.185C104.5 119.622 109.675 103.2 109.675 103.2C101.492 96.0556 98.7641 83.4562 101.752 82.2872C101.777 82.2772 101.803 82.2674 101.828 82.2579Z",
    fill: "url(#paint4_linear_1_17172)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M109.299 128.634C109.299 128.634 110.656 134.092 113.281 136.122",
    stroke: "#FFC4AF",
    strokeWidth: 0.994872,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0098 115.822C101.764 115.2 103.4 112.439 102.665 109.656C101.93 106.872 99.1009 105.12 96.3469 105.742C93.5929 106.364 91.9565 109.125 92.6918 111.909C93.4271 114.692 96.2558 116.444 99.0098 115.822Z",
    fill: "#B5BDCB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2201 108.36L96.1162 113.217",
    stroke: "#E9EBF0",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1611 109.022L100.175 112.444",
    stroke: "#E9EBF0",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.4,
    cy: 1.4,
    r: 1.4,
    transform: "matrix(-1 0 0 1 146.201 74.7995)",
    fill: "#7F8BA2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.4,
    cy: 1.4,
    r: 1.4,
    transform: "matrix(-1 0 0 1 138.735 74.7995)",
    fill: "#7F8BA2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.4,
    cy: 1.4,
    r: 1.4,
    transform: "matrix(-1 0 0 1 131.268 74.7995)",
    fill: "#7F8BA2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.4,
    cy: 1.4,
    r: 1.4,
    transform: "matrix(-1 0 0 1 123.801 74.7995)",
    fill: "#7F8BA2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_17172",
    x1: 72.9862,
    y1: 172.906,
    x2: 102.832,
    y2: 69.9372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6DBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F2F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_17172",
    x1: 74.1111,
    y1: 171.376,
    x2: 103.685,
    y2: 70.9619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6DBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F2F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_17172",
    x1: 96.2674,
    y1: 45.8654,
    x2: 86.9341,
    y2: 103.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_17172",
    x1: 100,
    y1: 154.791,
    x2: 106.288,
    y2: 146.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC4AF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_17172",
    x1: 107.934,
    y1: 113.532,
    x2: 117.268,
    y2: 104.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC4AF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailFeedback);
export default __webpack_public_path__ + "static/media/fail-feedback.d9bfa13cc257c072706539413403c8fc.svg";
export { ForwardRef as ReactComponent };